import eventBus, { EventKeys } from '@src/slide/infrastructure/module/independent/event-emitter/instance';
import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';

class AutoTestManager {
    private static instance: AutoTestManager | null = null;

    public  static getInstance(): AutoTestManager {
        if (!AutoTestManager.instance) {
            AutoTestManager.instance = new AutoTestManager();
        }
        return AutoTestManager.instance;
    }

    private constructor() {
        // eslint-disable-next-line no-undef
        if (__IS_DEV__ || ENV.IS_TEST) {
            eventBus.on(EventKeys.FIRST_PAGE_DISPLAY, () => {
                import(/* webpackChunkName: "auto-test" */ './auto-test-config').then((module) => {
                    if (module.default) {
                        // @ts-ignore
                        window.autoTestConfig = module.default;
                    }
                })
                    .catch((error) => {
                        window.log.error(`[loadChunk-error]${error}`);
                    });
            });
        }
    }
}

export default AutoTestManager;
